import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminBillingDashboardOrganizations: build.query<
      GetV2AdminBillingDashboardOrganizationsApiResponse,
      GetV2AdminBillingDashboardOrganizationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/organizations`,
        params: {
          search: queryArg.search,
          sort_by: queryArg.sortBy,
          sort_dir: queryArg.sortDir,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2AdminBillingDashboardOrganizationsByOrganizationId: build.query<
      GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiResponse,
      GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/billing/dashboard/organizations/${queryArg.organizationId}`,
      }),
    }),
    postV2AdminClaimRulesSeed: build.mutation<
      PostV2AdminClaimRulesSeedApiResponse,
      PostV2AdminClaimRulesSeedApiArg
    >({
      query: () => ({ url: `/v2/admin/claim-rules/seed`, method: "POST" }),
    }),
    getV2AdminClaimsByClaimIdReadiness: build.query<
      GetV2AdminClaimsByClaimIdReadinessApiResponse,
      GetV2AdminClaimsByClaimIdReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/claims/${queryArg.claimId}/readiness`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingEntities: build.query<
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdBillingEntities: build.mutation<
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse,
      PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities`,
        method: "POST",
        body: queryArg.createBillingEntityRequest,
      }),
    }),
    deleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "DELETE",
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.query<
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
        }),
      }),
    putV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityId:
      build.mutation<
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse,
        PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}`,
          method: "PUT",
          body: queryArg.updateBillingEntityRequest,
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadiness:
      build.query<
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiResponse,
        GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/payers/${queryArg.payerId}/readiness`,
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefault:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/set-default`,
          method: "POST",
        }),
      }),
    postV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStedi:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse,
        PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/billing-entities/${queryArg.billingEntityId}/sync-to-stedi`,
          method: "POST",
        }),
      }),
    getV2AdminOrgsByOrganizationIdBillingReadiness: build.query<
      GetV2AdminOrgsByOrganizationIdBillingReadinessApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing-readiness`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingPayerDocs: build.query<
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKey: build.query<
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse,
      GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs/${queryArg.payerKey}`,
      }),
    }),
    putV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKey: build.mutation<
      PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse,
      PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/billing/payer-docs/${queryArg.payerKey}`,
        method: "PUT",
        body: queryArg.payerDocUpsertRequest,
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollments: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollments: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments`,
        method: "POST",
        body: queryArg.initiateEnrollmentRequest,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsSyncAll: build.mutation<
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse,
      PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/sync-all`,
        method: "POST",
      }),
    }),
    getV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentId: build.query<
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse,
      GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSync:
      build.mutation<
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse,
        PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/enrollments/${queryArg.enrollmentId}/sync`,
          method: "POST",
        }),
      }),
    getV2AdminOrgsByOrganizationIdRemittances: build.query<
      GetV2AdminOrgsByOrganizationIdRemittancesApiResponse,
      GetV2AdminOrgsByOrganizationIdRemittancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/remittances`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummary:
      build.query<
        GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiResponse,
        GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/remittances/claims/${queryArg.claimId}/summary`,
        }),
      }),
    getV2AdminOrgsByOrganizationIdRemittancesAndRemittanceId: build.query<
      GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiResponse,
      GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/remittances/${queryArg.remittanceId}`,
      }),
    }),
    postV2AdminOrgsByOrganizationIdStediConnect: build.mutation<
      PostV2AdminOrgsByOrganizationIdStediConnectApiResponse,
      PostV2AdminOrgsByOrganizationIdStediConnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/connect`,
        method: "POST",
        body: queryArg.connectStediRequest,
      }),
    }),
    deleteV2AdminOrgsByOrganizationIdStediDisconnect: build.mutation<
      DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiResponse,
      DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/disconnect`,
        method: "DELETE",
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediStatus: build.query<
      GetV2AdminOrgsByOrganizationIdStediStatusApiResponse,
      GetV2AdminOrgsByOrganizationIdStediStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/status`,
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediTransactions: build.query<
      GetV2AdminOrgsByOrganizationIdStediTransactionsApiResponse,
      GetV2AdminOrgsByOrganizationIdStediTransactionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/transactions`,
        params: {
          page_size: queryArg.pageSize,
          page_token: queryArg.pageToken,
          from_date: queryArg.fromDate,
          to_date: queryArg.toDate,
          direction: queryArg.direction,
          mode: queryArg.mode,
          status: queryArg.status,
          transaction_set_id: queryArg.transactionSetId,
        },
      }),
    }),
    getV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionId:
      build.query<
        GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiResponse,
        GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/transactions/${queryArg.transactionId}`,
        }),
      }),
    postV2AdminOrgsByOrganizationIdStediVerify: build.mutation<
      PostV2AdminOrgsByOrganizationIdStediVerifyApiResponse,
      PostV2AdminOrgsByOrganizationIdStediVerifyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/orgs/${queryArg.organizationId}/stedi/verify`,
        method: "POST",
      }),
    }),
    postV2AdminPayersSync: build.mutation<
      PostV2AdminPayersSyncApiResponse,
      PostV2AdminPayersSyncApiArg
    >({
      query: () => ({ url: `/v2/admin/payers/sync`, method: "POST" }),
    }),
    getV2AdminPayersSyncStatus: build.query<
      GetV2AdminPayersSyncStatusApiResponse,
      GetV2AdminPayersSyncStatusApiArg
    >({
      query: () => ({ url: `/v2/admin/payers/sync-status` }),
    }),
    getV2ProviderBillingEntities: build.query<
      GetV2ProviderBillingEntitiesApiResponse,
      GetV2ProviderBillingEntitiesApiArg
    >({
      query: () => ({ url: `/v2/provider/billing-entities` }),
    }),
    postV2ProviderBillingEntities: build.mutation<
      PostV2ProviderBillingEntitiesApiResponse,
      PostV2ProviderBillingEntitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities`,
        method: "POST",
        body: queryArg.createBillingEntityRequest,
      }),
    }),
    deleteV2ProviderBillingEntitiesByBillingEntityId: build.mutation<
      DeleteV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      DeleteV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderBillingEntitiesByBillingEntityId: build.query<
      GetV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      GetV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
      }),
    }),
    putV2ProviderBillingEntitiesByBillingEntityId: build.mutation<
      PutV2ProviderBillingEntitiesByBillingEntityIdApiResponse,
      PutV2ProviderBillingEntitiesByBillingEntityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}`,
        method: "PUT",
        body: queryArg.updateBillingEntityRequest,
      }),
    }),
    postV2ProviderBillingEntitiesByBillingEntityIdSetDefault: build.mutation<
      PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiResponse,
      PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}/set-default`,
        method: "POST",
      }),
    }),
    postV2ProviderBillingEntitiesByBillingEntityIdSyncToStedi: build.mutation<
      PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiResponse,
      PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-entities/${queryArg.billingEntityId}/sync-to-stedi`,
        method: "POST",
      }),
    }),
    getV2ProviderBillingMigrationSessions: build.query<
      GetV2ProviderBillingMigrationSessionsApiResponse,
      GetV2ProviderBillingMigrationSessionsApiArg
    >({
      query: () => ({ url: `/v2/provider/billing-migration/sessions` }),
    }),
    deleteV2ProviderBillingMigrationSessionsBySessionId: build.mutation<
      DeleteV2ProviderBillingMigrationSessionsBySessionIdApiResponse,
      DeleteV2ProviderBillingMigrationSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-migration/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderBillingMigrationSessionsBySessionId: build.query<
      GetV2ProviderBillingMigrationSessionsBySessionIdApiResponse,
      GetV2ProviderBillingMigrationSessionsBySessionIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-migration/sessions/${queryArg.sessionId}`,
      }),
    }),
    postV2ProviderBillingMigrationSessionsBySessionIdConfirm: build.mutation<
      PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiResponse,
      PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing-migration/sessions/${queryArg.sessionId}/confirm`,
        method: "POST",
      }),
    }),
    postV2ProviderBillingMigrationUpload: build.mutation<
      PostV2ProviderBillingMigrationUploadApiResponse,
      PostV2ProviderBillingMigrationUploadApiArg
    >({
      query: () => ({
        url: `/v2/provider/billing-migration/upload`,
        method: "POST",
      }),
    }),
    getV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerId:
      build.query<
        GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiResponse,
        GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/billing-readiness/billing-entities/${queryArg.billingEntityId}/payers/${queryArg.payerId}`,
        }),
      }),
    getV2ProviderBillingReadinessOrg: build.query<
      GetV2ProviderBillingReadinessOrgApiResponse,
      GetV2ProviderBillingReadinessOrgApiArg
    >({
      query: () => ({ url: `/v2/provider/billing-readiness/org` }),
    }),
    postV2ProviderBillingCharges: build.mutation<
      PostV2ProviderBillingChargesApiResponse,
      PostV2ProviderBillingChargesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/charges`,
        method: "POST",
        body: queryArg.captureChargesRequest,
      }),
    }),
    getV2ProviderBillingClaims: build.query<
      GetV2ProviderBillingClaimsApiResponse,
      GetV2ProviderBillingClaimsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          insurance_payer_id: queryArg.insurancePayerId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          submission_date_from: queryArg.submissionDateFrom,
          submission_date_to: queryArg.submissionDateTo,
          charge_min: queryArg.chargeMin,
          charge_max: queryArg.chargeMax,
          balance_min: queryArg.balanceMin,
          balance_max: queryArg.balanceMax,
          source_system: queryArg.sourceSystem,
          claim_type: queryArg.claimType,
          queue: queryArg.queue,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingClaimsQueueCounts: build.query<
      GetV2ProviderBillingClaimsQueueCountsApiResponse,
      GetV2ProviderBillingClaimsQueueCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims/queue-counts`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          insurance_payer_id: queryArg.insurancePayerId,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          submission_date_from: queryArg.submissionDateFrom,
          submission_date_to: queryArg.submissionDateTo,
          charge_min: queryArg.chargeMin,
          charge_max: queryArg.chargeMax,
          balance_min: queryArg.balanceMin,
          balance_max: queryArg.balanceMax,
          source_system: queryArg.sourceSystem,
          claim_type: queryArg.claimType,
          queue: queryArg.queue,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingClaimsByClaimId: build.query<
      GetV2ProviderBillingClaimsByClaimIdApiResponse,
      GetV2ProviderBillingClaimsByClaimIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/claims/${queryArg.claimId}`,
      }),
    }),
    postV2ProviderBillingCptChargesLookup: build.mutation<
      PostV2ProviderBillingCptChargesLookupApiResponse,
      PostV2ProviderBillingCptChargesLookupApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/cpt-charges/lookup`,
        method: "POST",
        body: queryArg.cptChargesLookupRequest,
      }),
    }),
    getV2ProviderBillingCptChargesByCptCode: build.query<
      GetV2ProviderBillingCptChargesByCptCodeApiResponse,
      GetV2ProviderBillingCptChargesByCptCodeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/cpt-charges/${queryArg.cptCode}`,
      }),
    }),
    getV2ProviderBillingEncounters: build.query<
      GetV2ProviderBillingEncountersApiResponse,
      GetV2ProviderBillingEncountersApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters`,
        params: {
          patient_id: queryArg.patientId,
          provider_ids: queryArg.providerIds,
          status: queryArg.status,
          billable: queryArg.billable,
          has_claim: queryArg.hasClaim,
          ready_to_bill: queryArg.readyToBill,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    getV2ProviderBillingEncountersByEncounterId: build.query<
      GetV2ProviderBillingEncountersByEncounterIdApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}`,
      }),
    }),
    getV2ProviderBillingEncountersByEncounterIdReadiness: build.query<
      GetV2ProviderBillingEncountersByEncounterIdReadinessApiResponse,
      GetV2ProviderBillingEncountersByEncounterIdReadinessApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/encounters/${queryArg.encounterId}/readiness`,
      }),
    }),
    getV2ProviderBillingFeeSchedulesBaseline: build.query<
      GetV2ProviderBillingFeeSchedulesBaselineApiResponse,
      GetV2ProviderBillingFeeSchedulesBaselineApiArg
    >({
      query: () => ({ url: `/v2/provider/billing/fee-schedules/baseline` }),
    }),
    putV2ProviderBillingFeeSchedulesBaseline: build.mutation<
      PutV2ProviderBillingFeeSchedulesBaselineApiResponse,
      PutV2ProviderBillingFeeSchedulesBaselineApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/fee-schedules/baseline`,
        method: "PUT",
        body: queryArg.baselineRatesUpsertRequest,
      }),
    }),
    deleteV2ProviderBillingFeeSchedulesBaselineByCodeId: build.mutation<
      DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiResponse,
      DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/fee-schedules/baseline/${queryArg.codeId}`,
        method: "DELETE",
      }),
    }),
    postV2ProviderBillingFeeSchedulesFromExtraction: build.mutation<
      PostV2ProviderBillingFeeSchedulesFromExtractionApiResponse,
      PostV2ProviderBillingFeeSchedulesFromExtractionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/fee-schedules/from-extraction`,
        method: "POST",
        body: queryArg.feeScheduleImportRequest,
      }),
    }),
    getV2ProviderBillingInvoices: build.query<
      GetV2ProviderBillingInvoicesApiResponse,
      GetV2ProviderBillingInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/invoices`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          status: queryArg.status,
          patient_id: queryArg.patientId,
        },
      }),
    }),
    getV2ProviderBillingPatientsByPatientIdBalance: build.query<
      GetV2ProviderBillingPatientsByPatientIdBalanceApiResponse,
      GetV2ProviderBillingPatientsByPatientIdBalanceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/patients/${queryArg.patientId}/balance`,
        params: {
          encounter_id: queryArg.encounterId,
          party_type: queryArg.partyType,
          entry_type: queryArg.entryType,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2ProviderBillingPatientsByPatientIdPayments: build.mutation<
      PostV2ProviderBillingPatientsByPatientIdPaymentsApiResponse,
      PostV2ProviderBillingPatientsByPatientIdPaymentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/patients/${queryArg.patientId}/payments`,
        method: "POST",
        body: queryArg.recordPaymentRequest,
      }),
    }),
    getV2ProviderBillingPayerDocs: build.query<
      GetV2ProviderBillingPayerDocsApiResponse,
      GetV2ProviderBillingPayerDocsApiArg
    >({
      query: () => ({ url: `/v2/provider/billing/payer-docs` }),
    }),
    getV2ProviderBillingPayerDocsByPayerKey: build.query<
      GetV2ProviderBillingPayerDocsByPayerKeyApiResponse,
      GetV2ProviderBillingPayerDocsByPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/payer-docs/${queryArg.payerKey}`,
      }),
    }),
    putV2ProviderBillingPayerDocsByPayerKey: build.mutation<
      PutV2ProviderBillingPayerDocsByPayerKeyApiResponse,
      PutV2ProviderBillingPayerDocsByPayerKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/payer-docs/${queryArg.payerKey}`,
        method: "PUT",
        body: queryArg.payerDocUpsertRequest,
      }),
    }),
    getV2ProviderBillingRemittances: build.query<
      GetV2ProviderBillingRemittancesApiResponse,
      GetV2ProviderBillingRemittancesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          payer_name: queryArg.payerName,
          payment_method: queryArg.paymentMethod,
          source_system: queryArg.sourceSystem,
          amount_min: queryArg.amountMin,
          amount_max: queryArg.amountMax,
          queue: queryArg.queue,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2ProviderBillingRemittancesClaimsByClaimIdSummary: build.query<
      GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiResponse,
      GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances/claims/${queryArg.claimId}/summary`,
      }),
    }),
    getV2ProviderBillingRemittancesQueueCounts: build.query<
      GetV2ProviderBillingRemittancesQueueCountsApiResponse,
      GetV2ProviderBillingRemittancesQueueCountsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances/queue-counts`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
          payer_name: queryArg.payerName,
          payment_method: queryArg.paymentMethod,
          source_system: queryArg.sourceSystem,
          amount_min: queryArg.amountMin,
          amount_max: queryArg.amountMax,
          queue: queryArg.queue,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    getV2ProviderBillingRemittancesByRemittanceId: build.query<
      GetV2ProviderBillingRemittancesByRemittanceIdApiResponse,
      GetV2ProviderBillingRemittancesByRemittanceIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/remittances/${queryArg.remittanceId}`,
      }),
    }),
    getV2ProviderBillingStatementsHistory: build.query<
      GetV2ProviderBillingStatementsHistoryApiResponse,
      GetV2ProviderBillingStatementsHistoryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/statements/history`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          trigger_type: queryArg.triggerType,
          date_from: queryArg.dateFrom,
          date_to: queryArg.dateTo,
        },
      }),
    }),
    getV2ProviderBillingStatementsQueue: build.query<
      GetV2ProviderBillingStatementsQueueApiResponse,
      GetV2ProviderBillingStatementsQueueApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/billing/statements/queue`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    putV2ProviderEncountersByEncounterIdWorkingBillingClaim: build.mutation<
      PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiResponse,
      PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/encounters/${queryArg.encounterId}/working-billing-claim`,
        method: "PUT",
        body: queryArg.workingBillingClaimPutRequest,
      }),
    }),
    getV2ProviderEnrollments: build.query<
      GetV2ProviderEnrollmentsApiResponse,
      GetV2ProviderEnrollmentsApiArg
    >({
      query: () => ({ url: `/v2/provider/enrollments` }),
    }),
    postV2ProviderEnrollments: build.mutation<
      PostV2ProviderEnrollmentsApiResponse,
      PostV2ProviderEnrollmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments`,
        method: "POST",
        body: queryArg.initiateEnrollmentRequest,
      }),
    }),
    postV2ProviderEnrollmentsSyncAll: build.mutation<
      PostV2ProviderEnrollmentsSyncAllApiResponse,
      PostV2ProviderEnrollmentsSyncAllApiArg
    >({
      query: () => ({
        url: `/v2/provider/enrollments/sync-all`,
        method: "POST",
      }),
    }),
    getV2ProviderEnrollmentsByEnrollmentId: build.query<
      GetV2ProviderEnrollmentsByEnrollmentIdApiResponse,
      GetV2ProviderEnrollmentsByEnrollmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}`,
      }),
    }),
    postV2ProviderEnrollmentsByEnrollmentIdSync: build.mutation<
      PostV2ProviderEnrollmentsByEnrollmentIdSyncApiResponse,
      PostV2ProviderEnrollmentsByEnrollmentIdSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/enrollments/${queryArg.enrollmentId}/sync`,
        method: "POST",
      }),
    }),
    getV2ProviderServiceFacilities: build.query<
      GetV2ProviderServiceFacilitiesApiResponse,
      GetV2ProviderServiceFacilitiesApiArg
    >({
      query: () => ({ url: `/v2/provider/service-facilities` }),
    }),
    postV2ProviderServiceFacilities: build.mutation<
      PostV2ProviderServiceFacilitiesApiResponse,
      PostV2ProviderServiceFacilitiesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities`,
        method: "POST",
        body: queryArg.createServiceFacilityRequest,
      }),
    }),
    deleteV2ProviderServiceFacilitiesByServiceFacilityId: build.mutation<
      DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse,
      DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}`,
        method: "DELETE",
      }),
    }),
    getV2ProviderServiceFacilitiesByServiceFacilityId: build.query<
      GetV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse,
      GetV2ProviderServiceFacilitiesByServiceFacilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}`,
      }),
    }),
    putV2ProviderServiceFacilitiesByServiceFacilityId: build.mutation<
      PutV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse,
      PutV2ProviderServiceFacilitiesByServiceFacilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}`,
        method: "PUT",
        body: queryArg.updateServiceFacilityRequest,
      }),
    }),
    postV2ProviderServiceFacilitiesByServiceFacilityIdSetDefault:
      build.mutation<
        PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiResponse,
        PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/service-facilities/${queryArg.serviceFacilityId}/set-default`,
          method: "POST",
        }),
      }),
    postV2ProviderStediConnect: build.mutation<
      PostV2ProviderStediConnectApiResponse,
      PostV2ProviderStediConnectApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/stedi/connect`,
        method: "POST",
        body: queryArg.connectStediRequest,
      }),
    }),
    deleteV2ProviderStediDisconnect: build.mutation<
      DeleteV2ProviderStediDisconnectApiResponse,
      DeleteV2ProviderStediDisconnectApiArg
    >({
      query: () => ({ url: `/v2/provider/stedi/disconnect`, method: "DELETE" }),
    }),
    getV2ProviderStediStatus: build.query<
      GetV2ProviderStediStatusApiResponse,
      GetV2ProviderStediStatusApiArg
    >({
      query: () => ({ url: `/v2/provider/stedi/status` }),
    }),
    postV2ProviderStediVerify: build.mutation<
      PostV2ProviderStediVerifyApiResponse,
      PostV2ProviderStediVerifyApiArg
    >({
      query: () => ({ url: `/v2/provider/stedi/verify`, method: "POST" }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminBillingDashboardOrganizationsApiResponse =
  /** status 200 OK */ OrganizationBillingListResponse;
export type GetV2AdminBillingDashboardOrganizationsApiArg = {
  /** Search organizations by name */
  search?: string | null;
  /** Column to sort by (e.g. claims_needs_attention, denial_rate_pct, oldest_draft_age_days) */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortDir?: string;
  /** Page number */
  page?: number;
  /** Items per page (max 100) */
  perPage?: number;
};
export type GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiResponse =
  /** status 200 OK */ OrganizationBillingDetailResponse;
export type GetV2AdminBillingDashboardOrganizationsByOrganizationIdApiArg = {
  organizationId: string;
};
export type PostV2AdminClaimRulesSeedApiResponse =
  /** status 200 OK */ RuleSeedResponse;
export type PostV2AdminClaimRulesSeedApiArg = void;
export type GetV2AdminClaimsByClaimIdReadinessApiResponse =
  /** status 200 OK */ ClaimSubmissionReadinessResponse;
export type GetV2AdminClaimsByClaimIdReadinessApiArg = {
  claimId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityListResponse;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesApiArg = {
  organizationId: string;
  createBillingEntityRequest: CreateBillingEntityRequest;
};
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityDeleteResponse;
export type DeleteV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PutV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdApiArg =
  {
    organizationId: string;
    billingEntityId: string;
    updateBillingEntityRequest: UpdateBillingEntityRequest;
  };
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiResponse =
  /** status 200 OK */ PayerReadinessResponse;
export type GetV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdPayersPayerIdReadinessApiArg =
  {
    organizationId: string;
    billingEntityId: string;
    payerId: string;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSetDefaultApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiResponse =
  /** status 200 OK */ SyncToStediResponse;
export type PostV2AdminOrgsByOrganizationIdBillingEntitiesAndBillingEntityIdSyncToStediApiArg =
  {
    organizationId: string;
    billingEntityId: string;
  };
export type GetV2AdminOrgsByOrganizationIdBillingReadinessApiResponse =
  /** status 200 OK */ OrgBillingReadinessResponse;
export type GetV2AdminOrgsByOrganizationIdBillingReadinessApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiResponse =
  /** status 200 OK */ PayerDocListResponse;
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type GetV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg = {
  organizationId: string;
  payerKey: string;
};
export type PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type PutV2AdminOrgsByOrganizationIdBillingPayerDocsAndPayerKeyApiArg = {
  organizationId: string;
  payerKey: string;
  payerDocUpsertRequest: PayerDocUpsertRequest;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentListResponse;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsApiArg = {
  organizationId: string;
  initiateEnrollmentRequest: InitiateEnrollmentRequest;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiResponse =
  /** status 200 OK */ SyncAllResponse;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsSyncAllApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type GetV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdApiArg = {
  organizationId: string;
  enrollmentId: string;
};
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2AdminOrgsByOrganizationIdEnrollmentsAndEnrollmentIdSyncApiArg =
  {
    organizationId: string;
    enrollmentId: string;
  };
export type GetV2AdminOrgsByOrganizationIdRemittancesApiResponse =
  /** status 200 OK */ RemittanceListResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesApiArg = {
  organizationId: string;
  /** Page number (1-based) */
  page?: number;
  /** Number of items per page (max 100) */
  perPage?: number;
  /** Filter: earliest created_at date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter: latest created_at date (YYYY-MM-DD) */
  dateTo?: string | null;
};
export type GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiResponse =
  /** status 200 OK */ ClaimRemittanceSummaryResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesClaimsAndClaimIdSummaryApiArg =
  {
    organizationId: string;
    claimId: string;
  };
export type GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiResponse =
  /** status 200 OK */ RemittanceDetailResponse;
export type GetV2AdminOrgsByOrganizationIdRemittancesAndRemittanceIdApiArg = {
  organizationId: string;
  remittanceId: string;
};
export type PostV2AdminOrgsByOrganizationIdStediConnectApiResponse =
  /** status 200 OK */ ConnectStediResponse;
export type PostV2AdminOrgsByOrganizationIdStediConnectApiArg = {
  organizationId: string;
  connectStediRequest: ConnectStediRequest;
};
export type DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiResponse =
  /** status 200 OK */ DisconnectStediResponse;
export type DeleteV2AdminOrgsByOrganizationIdStediDisconnectApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdStediStatusApiResponse =
  /** status 200 OK */ StediConnectionStatusResponse;
export type GetV2AdminOrgsByOrganizationIdStediStatusApiArg = {
  organizationId: string;
};
export type GetV2AdminOrgsByOrganizationIdStediTransactionsApiResponse =
  /** status 200 OK */ StediTransactionListResponse;
export type GetV2AdminOrgsByOrganizationIdStediTransactionsApiArg = {
  organizationId: string;
  /** Results per page (1-500, default 100) */
  pageSize?: number | null;
  /** Cursor token from a previous response for pagination */
  pageToken?: string | null;
  /** ISO 8601 start of time range filter (e.g., 2026-02-01T00:00:00Z) */
  fromDate?: string | null;
  /** ISO 8601 end of time range filter */
  toDate?: string | null;
  /** Filter by direction: INBOUND, OUTBOUND, or UNKNOWN */
  direction?: string | null;
  /** Filter by mode: test, production, or other */
  mode?: string | null;
  /** Filter by status: failed or succeeded */
  status?: string | null;
  /** X12 transaction set code (e.g., 277, 835, 837) */
  transactionSetId?: string | null;
};
export type GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiResponse =
  /** status 200 OK */ StediTransactionDetailResponse;
export type GetV2AdminOrgsByOrganizationIdStediTransactionsAndTransactionIdApiArg =
  {
    organizationId: string;
    transactionId: string;
  };
export type PostV2AdminOrgsByOrganizationIdStediVerifyApiResponse =
  /** status 200 OK */ VerifyStediResponse;
export type PostV2AdminOrgsByOrganizationIdStediVerifyApiArg = {
  organizationId: string;
};
export type PostV2AdminPayersSyncApiResponse =
  /** status 202 Accepted */ PayerSyncResponse;
export type PostV2AdminPayersSyncApiArg = void;
export type GetV2AdminPayersSyncStatusApiResponse =
  /** status 200 OK */ PayerSyncStatusResponse;
export type GetV2AdminPayersSyncStatusApiArg = void;
export type GetV2ProviderBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityListResponse;
export type GetV2ProviderBillingEntitiesApiArg = void;
export type PostV2ProviderBillingEntitiesApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2ProviderBillingEntitiesApiArg = {
  createBillingEntityRequest: CreateBillingEntityRequest;
};
export type DeleteV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityDeleteResponse;
export type DeleteV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
};
export type GetV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type GetV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
};
export type PutV2ProviderBillingEntitiesByBillingEntityIdApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PutV2ProviderBillingEntitiesByBillingEntityIdApiArg = {
  billingEntityId: string;
  updateBillingEntityRequest: UpdateBillingEntityRequest;
};
export type PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiResponse =
  /** status 200 OK */ BillingEntityResponse2;
export type PostV2ProviderBillingEntitiesByBillingEntityIdSetDefaultApiArg = {
  billingEntityId: string;
};
export type PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiResponse =
  /** status 200 OK */ SyncToStediResponse;
export type PostV2ProviderBillingEntitiesByBillingEntityIdSyncToStediApiArg = {
  billingEntityId: string;
};
export type GetV2ProviderBillingMigrationSessionsApiResponse =
  /** status 200 OK */ BillingMigrationSessionListResponse;
export type GetV2ProviderBillingMigrationSessionsApiArg = void;
export type DeleteV2ProviderBillingMigrationSessionsBySessionIdApiResponse =
  /** status 200 OK */ BillingMigrationSessionResponse2;
export type DeleteV2ProviderBillingMigrationSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type GetV2ProviderBillingMigrationSessionsBySessionIdApiResponse =
  /** status 200 OK */ BillingMigrationSessionResponse2;
export type GetV2ProviderBillingMigrationSessionsBySessionIdApiArg = {
  sessionId: string;
};
export type PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiResponse =
  /** status 200 OK */ BillingMigrationConfirmResponse;
export type PostV2ProviderBillingMigrationSessionsBySessionIdConfirmApiArg = {
  sessionId: string;
};
export type PostV2ProviderBillingMigrationUploadApiResponse =
  /** status 200 OK */ BillingMigrationUploadResponse;
export type PostV2ProviderBillingMigrationUploadApiArg = void;
export type GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiResponse =
  /** status 200 OK */ PayerReadinessResponse;
export type GetV2ProviderBillingReadinessBillingEntitiesByBillingEntityIdPayersAndPayerIdApiArg =
  {
    billingEntityId: string;
    payerId: string;
  };
export type GetV2ProviderBillingReadinessOrgApiResponse =
  /** status 200 OK */ OrgBillingReadinessResponse;
export type GetV2ProviderBillingReadinessOrgApiArg = void;
export type PostV2ProviderBillingChargesApiResponse =
  /** status 201 Created */ CaptureChargesResponse;
export type PostV2ProviderBillingChargesApiArg = {
  captureChargesRequest: CaptureChargesRequest;
};
export type GetV2ProviderBillingClaimsApiResponse =
  /** status 200 OK */ OrgClaimListResponse;
export type GetV2ProviderBillingClaimsApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected, paid, partially_paid, denied, reversed, imported) */
  status?: string | null;
  /** Filter by insurance payer ID */
  insurancePayerId?: string | null;
  /** Filter claims with service date from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter claims with service date up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Filter claims submitted from this date (ISO 8601) */
  submissionDateFrom?: string | null;
  /** Filter claims submitted up to this date (ISO 8601) */
  submissionDateTo?: string | null;
  /** Minimum total_charge_cents */
  chargeMin?: number | null;
  /** Maximum total_charge_cents */
  chargeMax?: number | null;
  /** Minimum balance_due_cents */
  balanceMin?: number | null;
  /** Maximum balance_due_cents */
  balanceMax?: number | null;
  /** Filter by source system (jotpsych, collabmd, etc.) */
  sourceSystem?: string | null;
  /** Filter by claim type (original, corrected, void) */
  claimType?: string | null;
  /** Smart queue filter (needs_attention, ready_to_submit, blocked, submitted, denied, paid, imported). Overrides status if both provided. */
  queue?: string | null;
  /** Field to sort by (created_at, service_date_from, total_charge_cents) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingClaimsQueueCountsApiResponse =
  /** status 200 OK */ ClaimQueueCounts;
export type GetV2ProviderBillingClaimsQueueCountsApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected, paid, partially_paid, denied, reversed, imported) */
  status?: string | null;
  /** Filter by insurance payer ID */
  insurancePayerId?: string | null;
  /** Filter claims with service date from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter claims with service date up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Filter claims submitted from this date (ISO 8601) */
  submissionDateFrom?: string | null;
  /** Filter claims submitted up to this date (ISO 8601) */
  submissionDateTo?: string | null;
  /** Minimum total_charge_cents */
  chargeMin?: number | null;
  /** Maximum total_charge_cents */
  chargeMax?: number | null;
  /** Minimum balance_due_cents */
  balanceMin?: number | null;
  /** Maximum balance_due_cents */
  balanceMax?: number | null;
  /** Filter by source system (jotpsych, collabmd, etc.) */
  sourceSystem?: string | null;
  /** Filter by claim type (original, corrected, void) */
  claimType?: string | null;
  /** Smart queue filter (needs_attention, ready_to_submit, blocked, submitted, denied, paid, imported). Overrides status if both provided. */
  queue?: string | null;
  /** Field to sort by (created_at, service_date_from, total_charge_cents) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingClaimsByClaimIdApiResponse =
  /** status 200 OK */ OrgClaimDetailResponse;
export type GetV2ProviderBillingClaimsByClaimIdApiArg = {
  claimId: string;
};
export type PostV2ProviderBillingCptChargesLookupApiResponse =
  /** status 200 OK */ CptChargesLookupResponse;
export type PostV2ProviderBillingCptChargesLookupApiArg = {
  cptChargesLookupRequest: CptChargesLookupRequest;
};
export type GetV2ProviderBillingCptChargesByCptCodeApiResponse =
  /** status 200 OK */ CptChargeResponse;
export type GetV2ProviderBillingCptChargesByCptCodeApiArg = {
  cptCode: string;
};
export type GetV2ProviderBillingEncountersApiResponse =
  /** status 200 OK */ OrgBillingEncounterListResponse;
export type GetV2ProviderBillingEncountersApiArg = {
  /** Filter by patient ID */
  patientId?: string | null;
  /** Comma-separated provider IDs to filter by */
  providerIds?: string | null;
  /** Filter by encounter status (e.g. completed) */
  status?: string | null;
  /** Filter by billable status */
  billable?: boolean | null;
  /** Filter by whether encounter has an associated claim */
  hasClaim?: boolean | null;
  /** Comma-separated ready-to-bill statuses to filter by (green, yellow, red) */
  readyToBill?: string | null;
  /** Filter encounters from this date (ISO 8601) */
  dateFrom?: string | null;
  /** Filter encounters up to this date (ISO 8601) */
  dateTo?: string | null;
  /** Field to sort by (scheduled_for, created_at) */
  sortBy?: string;
  /** Sort order (asc or desc) */
  sortOrder?: string;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type GetV2ProviderBillingEncountersByEncounterIdApiResponse =
  /** status 200 OK */ OrgBillingEncounterDetailResponse;
export type GetV2ProviderBillingEncountersByEncounterIdApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingEncountersByEncounterIdReadinessApiResponse =
  /** status 200 OK */ EncounterReadinessResponse;
export type GetV2ProviderBillingEncountersByEncounterIdReadinessApiArg = {
  encounterId: string;
};
export type GetV2ProviderBillingFeeSchedulesBaselineApiResponse =
  /** status 200 OK */ BaselineRatesGetResponse;
export type GetV2ProviderBillingFeeSchedulesBaselineApiArg = void;
export type PutV2ProviderBillingFeeSchedulesBaselineApiResponse =
  /** status 200 OK */ BaselineRatesUpsertResponse;
export type PutV2ProviderBillingFeeSchedulesBaselineApiArg = {
  baselineRatesUpsertRequest: BaselineRatesUpsertRequest;
};
export type DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiResponse =
  /** status 200 OK */ BaselineRateDeleteResponse;
export type DeleteV2ProviderBillingFeeSchedulesBaselineByCodeIdApiArg = {
  codeId: string;
};
export type PostV2ProviderBillingFeeSchedulesFromExtractionApiResponse =
  /** status 200 OK */ FeeScheduleImportResponse;
export type PostV2ProviderBillingFeeSchedulesFromExtractionApiArg = {
  feeScheduleImportRequest: FeeScheduleImportRequest;
};
export type GetV2ProviderBillingInvoicesApiResponse =
  /** status 200 OK */ OrgInvoiceListResponse;
export type GetV2ProviderBillingInvoicesApiArg = {
  /** Number of invoices to return */
  limit?: number;
  /** Offset for pagination */
  offset?: number;
  /** Filter by invoice status (draft, open, paid, uncollectible, void) */
  status?: string | null;
  /** Filter by patient ID */
  patientId?: string | null;
};
export type GetV2ProviderBillingPatientsByPatientIdBalanceApiResponse =
  /** status 200 OK */ PatientBalanceResponse;
export type GetV2ProviderBillingPatientsByPatientIdBalanceApiArg = {
  patientId: string;
  /** Filter entries to a single encounter */
  encounterId?: string | null;
  /** Filter by party type: payer or patient */
  partyType?: string | null;
  /** Filter by entry type: charge, payment, adjustment, etc. */
  entryType?: string | null;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type PostV2ProviderBillingPatientsByPatientIdPaymentsApiResponse =
  /** status 201 Created */ RecordPaymentResponse;
export type PostV2ProviderBillingPatientsByPatientIdPaymentsApiArg = {
  patientId: string;
  recordPaymentRequest: RecordPaymentRequest;
};
export type GetV2ProviderBillingPayerDocsApiResponse =
  /** status 200 OK */ PayerDocListResponse;
export type GetV2ProviderBillingPayerDocsApiArg = void;
export type GetV2ProviderBillingPayerDocsByPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type GetV2ProviderBillingPayerDocsByPayerKeyApiArg = {
  payerKey: string;
};
export type PutV2ProviderBillingPayerDocsByPayerKeyApiResponse =
  /** status 200 OK */ PayerDocResponse2;
export type PutV2ProviderBillingPayerDocsByPayerKeyApiArg = {
  payerKey: string;
  payerDocUpsertRequest: PayerDocUpsertRequest;
};
export type GetV2ProviderBillingRemittancesApiResponse =
  /** status 200 OK */ RemittanceListItemResponse;
export type GetV2ProviderBillingRemittancesApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Number of items per page (max 100) */
  perPage?: number;
  /** Filter: earliest payment_date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter: latest payment_date (YYYY-MM-DD) */
  dateTo?: string | null;
  /** Filter: payer name (case-insensitive partial match) */
  payerName?: string | null;
  /** Filter: payment method code (CHK or ACH) */
  paymentMethod?: string | null;
  /** Filter: source system (e.g. stedi, collabmd) */
  sourceSystem?: string | null;
  /** Filter: minimum total_payment_amount_cents */
  amountMin?: number | null;
  /** Filter: maximum total_payment_amount_cents */
  amountMax?: number | null;
  /** Smart queue filter: all, has_denials, reversals, clean, imported */
  queue?: string | null;
  /** Column to sort by (payment_date, total_payment_amount_cents, created_at, payer_name) */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortOrder?: string;
};
export type GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiResponse =
  /** status 200 OK */ ClaimRemittanceSummaryResponse;
export type GetV2ProviderBillingRemittancesClaimsByClaimIdSummaryApiArg = {
  claimId: string;
};
export type GetV2ProviderBillingRemittancesQueueCountsApiResponse =
  /** status 200 OK */ RemittanceQueueCounts;
export type GetV2ProviderBillingRemittancesQueueCountsApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Number of items per page (max 100) */
  perPage?: number;
  /** Filter: earliest payment_date (YYYY-MM-DD) */
  dateFrom?: string | null;
  /** Filter: latest payment_date (YYYY-MM-DD) */
  dateTo?: string | null;
  /** Filter: payer name (case-insensitive partial match) */
  payerName?: string | null;
  /** Filter: payment method code (CHK or ACH) */
  paymentMethod?: string | null;
  /** Filter: source system (e.g. stedi, collabmd) */
  sourceSystem?: string | null;
  /** Filter: minimum total_payment_amount_cents */
  amountMin?: number | null;
  /** Filter: maximum total_payment_amount_cents */
  amountMax?: number | null;
  /** Smart queue filter: all, has_denials, reversals, clean, imported */
  queue?: string | null;
  /** Column to sort by (payment_date, total_payment_amount_cents, created_at, payer_name) */
  sortBy?: string;
  /** Sort direction: asc or desc */
  sortOrder?: string;
};
export type GetV2ProviderBillingRemittancesByRemittanceIdApiResponse =
  /** status 200 OK */ RemittanceDetailResponse;
export type GetV2ProviderBillingRemittancesByRemittanceIdApiArg = {
  remittanceId: string;
};
export type GetV2ProviderBillingStatementsHistoryApiResponse =
  /** status 200 OK */ StatementHistoryListResponse;
export type GetV2ProviderBillingStatementsHistoryApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by trigger type (ERA_RECEIPT, MANUAL, etc.) */
  triggerType?: string | null;
  /** Filter: YYYY-MM-DD start date */
  dateFrom?: string | null;
  /** Filter: YYYY-MM-DD end date */
  dateTo?: string | null;
};
export type GetV2ProviderBillingStatementsQueueApiResponse =
  /** status 200 OK */ StatementQueueListResponse;
export type GetV2ProviderBillingStatementsQueueApiArg = {
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
};
export type PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiResponse =
  /** status 200 OK */ EncounterResponse;
export type PutV2ProviderEncountersByEncounterIdWorkingBillingClaimApiArg = {
  encounterId: string;
  workingBillingClaimPutRequest: WorkingBillingClaimPutRequest;
};
export type GetV2ProviderEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentListResponse;
export type GetV2ProviderEnrollmentsApiArg = void;
export type PostV2ProviderEnrollmentsApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsApiArg = {
  initiateEnrollmentRequest: InitiateEnrollmentRequest;
};
export type PostV2ProviderEnrollmentsSyncAllApiResponse =
  /** status 200 OK */ SyncAllResponse;
export type PostV2ProviderEnrollmentsSyncAllApiArg = void;
export type GetV2ProviderEnrollmentsByEnrollmentIdApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type GetV2ProviderEnrollmentsByEnrollmentIdApiArg = {
  enrollmentId: string;
};
export type PostV2ProviderEnrollmentsByEnrollmentIdSyncApiResponse =
  /** status 200 OK */ EnrollmentResponse2;
export type PostV2ProviderEnrollmentsByEnrollmentIdSyncApiArg = {
  enrollmentId: string;
};
export type GetV2ProviderServiceFacilitiesApiResponse =
  /** status 200 OK */ ServiceFacilityListResponse;
export type GetV2ProviderServiceFacilitiesApiArg = void;
export type PostV2ProviderServiceFacilitiesApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type PostV2ProviderServiceFacilitiesApiArg = {
  createServiceFacilityRequest: CreateServiceFacilityRequest;
};
export type DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse =
  /** status 200 OK */ ServiceFacilityDeleteResponse;
export type DeleteV2ProviderServiceFacilitiesByServiceFacilityIdApiArg = {
  serviceFacilityId: string;
};
export type GetV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type GetV2ProviderServiceFacilitiesByServiceFacilityIdApiArg = {
  serviceFacilityId: string;
};
export type PutV2ProviderServiceFacilitiesByServiceFacilityIdApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type PutV2ProviderServiceFacilitiesByServiceFacilityIdApiArg = {
  serviceFacilityId: string;
  updateServiceFacilityRequest: UpdateServiceFacilityRequest;
};
export type PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiResponse =
  /** status 200 OK */ ServiceFacilityResponse2;
export type PostV2ProviderServiceFacilitiesByServiceFacilityIdSetDefaultApiArg =
  {
    serviceFacilityId: string;
  };
export type PostV2ProviderStediConnectApiResponse =
  /** status 200 OK */ ConnectStediResponse;
export type PostV2ProviderStediConnectApiArg = {
  connectStediRequest: ConnectStediRequest;
};
export type DeleteV2ProviderStediDisconnectApiResponse =
  /** status 200 OK */ DisconnectStediResponse;
export type DeleteV2ProviderStediDisconnectApiArg = void;
export type GetV2ProviderStediStatusApiResponse =
  /** status 200 OK */ StediConnectionStatusResponse;
export type GetV2ProviderStediStatusApiArg = void;
export type PostV2ProviderStediVerifyApiResponse =
  /** status 200 OK */ VerifyStediResponse;
export type PostV2ProviderStediVerifyApiArg = void;
export type OrganizationBillingSummary = {
  active_billing_providers?: number;
  claims_created_last_30d?: number;
  claims_draft?: number;
  claims_in_flight?: number;
  claims_needs_attention?: number;
  claims_paid?: number;
  claims_ready?: number;
  claims_submitted_last_30d?: number;
  collection_rate_pct?: number | null;
  denial_count?: number;
  denial_rate_pct?: number | null;
  last_claim_created_at?: string | null;
  last_remittance_at?: string | null;
  last_submission_at?: string | null;
  oldest_draft_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  organization_id: string;
  organization_name?: string | null;
  rejection_count?: number;
  remittances_received?: number;
  reversal_count?: number;
  total_balance_cents?: number;
  total_charge_cents?: number;
  total_claims?: number;
  total_paid_cents?: number;
  total_remittance_payment_cents?: number;
  unmatched_remittance_claims?: number;
};
export type OrganizationBillingListResponse = {
  has_more?: boolean;
  organizations?: OrganizationBillingSummary[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type OrganizationBillingDetailResponse = {
  active_billing_providers?: number;
  claims_created_last_30d?: number;
  claims_draft?: number;
  claims_in_flight?: number;
  claims_needs_attention?: number;
  claims_paid?: number;
  claims_ready?: number;
  claims_submitted_last_30d?: number;
  collection_rate_pct?: number | null;
  denial_count?: number;
  denial_rate_pct?: number | null;
  encounters_ready_to_bill?: number | null;
  last_claim_created_at?: string | null;
  last_remittance_at?: string | null;
  last_submission_at?: string | null;
  oldest_draft_age_days?: number | null;
  oldest_ready_age_days?: number | null;
  organization_id: string;
  organization_name?: string | null;
  rejection_count?: number;
  remittances_received?: number;
  reversal_count?: number;
  total_balance_cents?: number;
  total_charge_cents?: number;
  total_claims?: number;
  total_paid_cents?: number;
  total_remittance_payment_cents?: number;
  unmatched_remittance_claims?: number;
};
export type RuleSeedResponse = {
  errors?: string[];
  message: string;
  rules_created: number;
  rules_skipped: number;
  success: boolean;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type SubmissionBlockerResponse = {
  /** Recommended action to resolve */
  action: string;
  /** Machine-readable blocker code */
  code: string;
  /** Additional context */
  details?: {
    [key: string]: any;
  } | null;
  /** Readiness level (1=org, 2=entity, 3=payer, 4=claim) */
  level: number;
  /** Human-readable description */
  message: string;
};
export type ClaimSubmissionReadinessResponse = {
  blockers: SubmissionBlockerResponse[];
  can_generate: boolean;
  can_submit: boolean;
  claim_id: string;
  enrollment_status: string | null;
  evaluated_at: string;
  payer_status: string | null;
  status: string;
};
export type BillingAddressResponse = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse = {
  billing_address: BillingAddressResponse;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingEntityListResponse = {
  billing_entities: BillingEntityResponse[];
};
export type BillingAddressResponse2 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type SyncStatus2 =
  | "NOT_SYNCED"
  | "SYNCED"
  | "SYNC_FAILED"
  | "NEEDS_RESYNC";
export type BillingEntityResponse2 = {
  billing_address: BillingAddressResponse2;
  billing_entity_id: string;
  billing_npi: string;
  contact_email: string | null;
  contact_name: string | null;
  contact_phone: string | null;
  created_at: string;
  doing_business_as: string | null;
  is_default: boolean;
  legal_name: string;
  organization_id: string;
  stedi_provider_id: string | null;
  stedi_synced: boolean;
  stedi_synced_at: string | null;
  sync_status: SyncStatus2;
  tax_id_masked: string;
  tax_id_type: string;
  taxonomy_code: string | null;
  updated_at: string;
};
export type BillingAddressSchema = {
  city: string;
  line1: string;
  line2?: string | null;
  state: string;
  zip: string;
};
export type CreateBillingEntityRequest = {
  billing_address: BillingAddressSchema;
  billing_npi: string;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean;
  legal_name: string;
  tax_id: string;
  tax_id_type: string;
  taxonomy_code?: string | null;
};
export type BillingEntityDeleteResponse = {
  /** Whether deletion was successful */
  deleted: boolean;
};
export type BillingAddressUpdateSchema = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type UpdateBillingEntityRequest = {
  billing_address?: BillingAddressUpdateSchema | null;
  billing_npi?: string | null;
  contact_email?: string | null;
  contact_name?: string | null;
  contact_phone?: string | null;
  doing_business_as?: string | null;
  is_default?: boolean | null;
  legal_name?: string | null;
  tax_id?: string | null;
  tax_id_type?: ("EIN" | "SSN") | null;
  taxonomy_code?: string | null;
};
export type PayerReadinessResponse = {
  action_required: string | null;
  blockers: string[];
  can_submit: boolean;
  enrollment_status: string | null;
  payer_name: string;
  payer_support: string;
  payer_uuid: string;
};
export type SyncToStediResponse = {
  error?: string | null;
  error_code?: string | null;
  stedi_provider_id?: string | null;
  success: boolean;
  synced_at?: string | null;
};
export type BillingEntityStatusResponse = {
  billing_entity_id: string;
  billing_npi: string | null;
  is_complete: boolean;
  is_default: boolean;
  is_synced: boolean;
  issues: string[];
  legal_name: string;
};
export type PayerEnrollmentStatusResponse = {
  action_required: string | null;
  can_submit: boolean;
  enrollment_status: string | null;
  payer_name: string;
  payer_support: string;
  payer_uuid: string;
  transaction_type: string;
};
export type OrgBillingReadinessResponse = {
  billing_entities: BillingEntityStatusResponse[];
  enrollment_summary: {
    [key: string]: PayerEnrollmentStatusResponse[];
  };
  evaluated_at: string;
  organization_id: string;
  overall_status: string;
  stedi_config_issues: string[];
  stedi_connected: boolean;
};
export type PayerDocResponse = {
  created_at?: string | null;
  organization_id: string;
  payer_doc_id: string;
  payer_key: string;
  payer_name?: string | null;
  payer_uuid?: string | null;
  payload?: {
    [key: string]: any;
  };
  updated_at?: string | null;
};
export type PayerDocListResponse = {
  items?: PayerDocResponse[];
  total: number;
};
export type PayerDocResponse2 = {
  created_at?: string | null;
  organization_id: string;
  payer_doc_id: string;
  payer_key: string;
  payer_name?: string | null;
  payer_uuid?: string | null;
  payload?: {
    [key: string]: any;
  };
  updated_at?: string | null;
};
export type PayerDocUpsertRequest = {
  /** Optional display name for this payer doc */
  payer_name?: string | null;
  /** Optional canonical payer reference (payers.id) */
  payer_uuid?: string | null;
  /** Raw payer JSON payload (jotbill-payer-contract-v2) */
  payload?: {
    [key: string]: any;
  };
};
export type EnrollmentResponse = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  transaction_type: string;
  updated_at: string;
};
export type EnrollmentListResponse = {
  enrollments: EnrollmentResponse[];
};
export type EnrollmentResponse2 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  transaction_type: string;
  updated_at: string;
};
export type InitiateEnrollmentRequest = {
  /** Billing entity to enroll */
  billing_entity_id: string;
  /** Internal payer UUID (from local database) */
  payer_uuid?: string | null;
  /** Stedi payer ID (from payer search results) */
  stedi_id?: string | null;
  /** Transaction type: 837P (claims) or 835 (ERA) */
  transaction_type?: string;
};
export type EnrollmentResponse3 = {
  billing_entity_id: string;
  created_at: string;
  last_synced_at: string | null;
  live_at: string | null;
  organization_id: string;
  /** Payer logo URL */
  payer_avatar_url?: string | null;
  /** Payer display name */
  payer_name?: string | null;
  payer_uuid: string | null;
  /** Payer website URL */
  payer_website_url?: string | null;
  rejection_reason: string | null;
  requested_at: string | null;
  status: string;
  status_message: string | null;
  stedi_enrollment_id: string | null;
  stedi_payer_id: string;
  stedi_transaction_enrollment_id: string;
  submitted_at: string | null;
  transaction_type: string;
  updated_at: string;
};
export type SyncAllResponse = {
  enrollments: EnrollmentResponse3[];
  synced_count: number;
};
export type RemittanceHeaderResponse = {
  /** 'test' or 'production' */
  application_mode?: string | null;
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Number of claims in this remittance */
  claim_count?: number;
  created_at?: string | null;
  organization_id: string;
  /** Name of the entity that received payment */
  payee_name?: string | null;
  /** NPI of the entity that received payment */
  payee_npi?: string | null;
  /** Payer's identifier code */
  payer_identifier?: string | null;
  /** Name of the paying entity */
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405). Use this instead of created_at for display. */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Origin of this ERA: 'stedi' (live) or source system slug for imports */
  source_system?: string | null;
  stedi_transaction_id?: string | null;
  /** Total payment in cents across all claims in this 835 */
  total_payment_amount_cents?: number | null;
  transaction_task_id?: string | null;
};
export type RemittanceListResponse = {
  /** List of remittance payment events for the current page */
  items?: RemittanceHeaderResponse[];
  /** Current page number (1-based) */
  page: number;
  /** Number of items per page */
  per_page: number;
  /** Total number of remittances matching filters */
  total: number;
  /** Total number of pages available */
  total_pages: number;
};
export type RemittanceLineResponse = {
  /** CPT/HCPCS code the payer adjudicated */
  adjudicated_procedure_code?: string | null;
  /** Modifier codes on the adjudicated procedure */
  adjudicated_procedure_modifier_codes?: string[] | null;
  claim_line_id?: string | null;
  /** Billed amount for this line in cents */
  line_item_charge_amount_cents?: number | null;
  /** Our submitted line control number */
  line_item_control_number?: string | null;
  /** Paid amount for this line in cents */
  line_item_payment_amount_cents?: number | null;
  original_units_of_service_count?: number | null;
  /** RARC remark codes. Each entry: {remarkCode, remark, codeListQualifierCode} */
  remark_codes?: {
    [key: string]: any;
  }[];
  remittance_line_id: string;
  /** Line-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents} */
  service_adjustments?: {
    [key: string]: any;
  }[];
  service_date?: string | null;
  /** Original submitted code (if payer changed it) */
  submitted_procedure_code?: string | null;
};
export type RemittanceClaimResponse = {
  /** Claim-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents}. groupCode: CO=contractual, PR=patient responsibility, OA=other, PI=payor initiated, CR=corrections */
  claim_adjustments?: {
    [key: string]: any;
  }[];
  /** 1=original, 7=replacement, 8=void */
  claim_frequency_code?: string | null;
  /** Matched internal claim ID (null if unmatched) */
  claim_id?: string | null;
  /** Amount paid in cents (CLP04) */
  claim_payment_amount_cents?: number | null;
  claim_received_date?: string | null;
  /** CLP02: 1=processed, 4=denied, 22=reversal, etc. */
  claim_status_code: string;
  /** Encounter ID from the linked claim (null if unmatched) */
  encounter_id?: string | null;
  /** True if payer forwarded to secondary insurance */
  forwarded_to_secondary?: boolean;
  /** Service line adjudication details */
  lines?: RemittanceLineResponse[];
  /** Our PCN used to match this to a claim */
  patient_control_number: string;
  patient_first_name?: string | null;
  patient_last_name?: string | null;
  patient_member_id?: string | null;
  /** Patient owes in cents (CLP05) */
  patient_responsibility_amount_cents?: number | null;
  /** Payer's internal claim reference (CLP07) */
  payer_claim_control_number?: string | null;
  remittance_claim_id: string;
  remittance_id: string;
  rendering_provider_npi?: string | null;
  statement_period_end?: string | null;
  statement_period_start?: string | null;
  /** Total billed amount in cents (CLP03) */
  total_claim_charge_amount_cents?: number | null;
};
export type ClaimRemittanceSummaryResponse = {
  claim_id: string;
  /** Trace number from the most recent 835 */
  latest_check_or_eft_trace_number?: string | null;
  /** Payer name from the most recent 835 */
  latest_payer_name?: string | null;
  /** Payment method from the most recent 835 */
  latest_payment_method_code?: string | null;
  /** Sum of all claim_payment_amount_cents across all 835s */
  net_payment_cents?: number;
  /** Remittance claim records with nested lines. Multiple entries means multiple 835s processed for this claim. */
  remittance_records?: RemittanceClaimResponse[];
  /** Sum of all adjustment amounts across all 835s */
  total_adjustments_cents?: number;
};
export type RemittanceLineResponse2 = {
  /** CPT/HCPCS code the payer adjudicated */
  adjudicated_procedure_code?: string | null;
  /** Modifier codes on the adjudicated procedure */
  adjudicated_procedure_modifier_codes?: string[] | null;
  claim_line_id?: string | null;
  /** Billed amount for this line in cents */
  line_item_charge_amount_cents?: number | null;
  /** Our submitted line control number */
  line_item_control_number?: string | null;
  /** Paid amount for this line in cents */
  line_item_payment_amount_cents?: number | null;
  original_units_of_service_count?: number | null;
  /** RARC remark codes. Each entry: {remarkCode, remark, codeListQualifierCode} */
  remark_codes?: {
    [key: string]: any;
  }[];
  remittance_line_id: string;
  /** Line-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents} */
  service_adjustments?: {
    [key: string]: any;
  }[];
  service_date?: string | null;
  /** Original submitted code (if payer changed it) */
  submitted_procedure_code?: string | null;
};
export type RemittanceClaimResponse2 = {
  /** Claim-level adjustments. Each entry: {groupCode, reasonCode, reasonDescription, amountCents}. groupCode: CO=contractual, PR=patient responsibility, OA=other, PI=payor initiated, CR=corrections */
  claim_adjustments?: {
    [key: string]: any;
  }[];
  /** 1=original, 7=replacement, 8=void */
  claim_frequency_code?: string | null;
  /** Matched internal claim ID (null if unmatched) */
  claim_id?: string | null;
  /** Amount paid in cents (CLP04) */
  claim_payment_amount_cents?: number | null;
  claim_received_date?: string | null;
  /** CLP02: 1=processed, 4=denied, 22=reversal, etc. */
  claim_status_code: string;
  /** Encounter ID from the linked claim (null if unmatched) */
  encounter_id?: string | null;
  /** True if payer forwarded to secondary insurance */
  forwarded_to_secondary?: boolean;
  /** Service line adjudication details */
  lines?: RemittanceLineResponse2[];
  /** Our PCN used to match this to a claim */
  patient_control_number: string;
  patient_first_name?: string | null;
  patient_last_name?: string | null;
  patient_member_id?: string | null;
  /** Patient owes in cents (CLP05) */
  patient_responsibility_amount_cents?: number | null;
  /** Payer's internal claim reference (CLP07) */
  payer_claim_control_number?: string | null;
  remittance_claim_id: string;
  remittance_id: string;
  rendering_provider_npi?: string | null;
  statement_period_end?: string | null;
  statement_period_start?: string | null;
  /** Total billed amount in cents (CLP03) */
  total_claim_charge_amount_cents?: number | null;
};
export type RemittanceHeaderResponse2 = {
  /** 'test' or 'production' */
  application_mode?: string | null;
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Number of claims in this remittance */
  claim_count?: number;
  created_at?: string | null;
  organization_id: string;
  /** Name of the entity that received payment */
  payee_name?: string | null;
  /** NPI of the entity that received payment */
  payee_npi?: string | null;
  /** Payer's identifier code */
  payer_identifier?: string | null;
  /** Name of the paying entity */
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405). Use this instead of created_at for display. */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Origin of this ERA: 'stedi' (live) or source system slug for imports */
  source_system?: string | null;
  stedi_transaction_id?: string | null;
  /** Total payment in cents across all claims in this 835 */
  total_payment_amount_cents?: number | null;
  transaction_task_id?: string | null;
};
export type RemittanceDetailResponse = {
  /** All claims adjudicated in this payment */
  claims?: RemittanceClaimResponse2[];
  remittance: RemittanceHeaderResponse2;
};
export type ConnectStediResponse = {
  /** Whether connection was successful */
  connected: boolean;
  /** When the connection was established */
  connected_at?: string | null;
  /** Status message */
  message?: string;
};
export type ConnectStediRequest = {
  /** Optional label for debugging/display (e.g., clinic name) */
  account_label?: string | null;
  /** Plaintext API key from Stedi app installation */
  api_key: string;
};
export type DisconnectStediResponse = {
  /** Whether disconnection was successful */
  disconnected: boolean;
  /** Status message */
  message?: string;
};
export type StediConnectionStatusResponse = {
  /** Account label for display */
  account_label?: string | null;
  /** Whether the org is connected to Stedi */
  connected: boolean;
  /** When the org first connected */
  connected_at?: string | null;
  /** Whether Stedi integration is enabled */
  enabled: boolean;
  /** When connection was last verified */
  last_verified_at?: string | null;
  /** Account mode: DEDICATED or SHARED */
  mode?: string | null;
  /** Last verification error, if any */
  verification_error?: string | null;
};
export type StediTransactionListResponse = {
  /** List of transaction objects from the Stedi Core API */
  items: {
    [key: string]: any;
  }[];
  /** Cursor token for the next page of results */
  next_page_token?: string | null;
};
export type StediTransactionDetailResponse = {
  /** Parsed JSON content of the transaction output artifact. For 837 claims: full claim payload (payer, subscriber, service lines, etc.). For 277/835: parsed report content. Null if the output artifact could not be fetched. */
  output?: {
    [key: string]: any;
  } | null;
  /** Full transaction metadata from the Stedi Core API */
  transaction: {
    [key: string]: any;
  };
};
export type VerifyStediResponse = {
  /** Error message if validation failed */
  error?: string | null;
  /** Whether the connection is valid */
  valid: boolean;
  /** When the verification was performed */
  verified_at?: string | null;
};
export type PayerSyncResponse = {
  message: string;
  success: boolean;
  task_id?: string | null;
};
export type PayerSyncStatusResponse = {
  last_synced_at?: string | null;
  message: string;
  payer_count: number;
};
export type BillingMigrationSessionResponse = {
  completed_at?: string | null;
  created_at?: string | null;
  error_messages?: {
    [key: string]: any;
  }[];
  import_stats?: {
    [key: string]: any;
  };
  organization_id: string;
  preview_data?: {
    [key: string]: any;
  } | null;
  session_id: string;
  source_system: string;
  status: string;
  updated_at?: string | null;
};
export type BillingMigrationSessionListResponse = {
  sessions: BillingMigrationSessionResponse[];
};
export type BillingMigrationSessionResponse2 = {
  completed_at?: string | null;
  created_at?: string | null;
  error_messages?: {
    [key: string]: any;
  }[];
  import_stats?: {
    [key: string]: any;
  };
  organization_id: string;
  preview_data?: {
    [key: string]: any;
  } | null;
  session_id: string;
  source_system: string;
  status: string;
  updated_at?: string | null;
};
export type BillingMigrationConfirmResponse = {
  import_stats?: {
    [key: string]: any;
  };
  session_id: string;
  status: string;
};
export type BillingMigrationUploadResponse = {
  files_received: number;
  session_id: string;
  status: string;
};
export type CaptureChargesResponse = {
  /** IDs of created charge lines */
  charge_line_ids: string[];
  /** Sum of all charge amounts */
  total_charge_cents: number;
};
export type ChargeItem = {
  /** Billing code (e.g., CPT:99214, HCPCS:H0031) */
  billing_code?: string | null;
  /** Charge amount in cents */
  charge_amount_cents: number;
  /** Service description */
  description?: string | null;
  /** Number of units */
  units?: number;
};
export type CaptureChargesRequest = {
  /** Encounter to associate charges with (optional) */
  encounter_id?: string | null;
  /** At least one charge item */
  items: ChargeItem[];
  /** Patient ID */
  patient_id: string;
};
export type ClaimListItem = {
  /** Amount paid by payer in cents */
  amount_paid_cents?: number | null;
  /** Balance due in cents */
  balance_due_cents?: number | null;
  /** Claim ID */
  claim_id: string;
  /** Claim type: original, corrected, or void */
  claim_type?: string | null;
  /** Whether this claim can be corrected (post-submission + has PCN) */
  correction_eligible?: boolean;
  /** When claim was created */
  created_at: string;
  /** Days elapsed since submission */
  days_since_submission?: number | null;
  /** Encounter ID for linking to encounter detail */
  encounter_id?: string | null;
  /** Number of ERROR severity annotations */
  error_count?: number;
  /** Whether this claim has correction or void children */
  has_children?: boolean;
  /** Whether any ERA has been received for this claim */
  has_remittance?: boolean;
  /** Number of INFO severity annotations */
  info_count?: number;
  /** One-sentence next action for billing staff */
  next_action?: string | null;
  /** Priority level: urgent, action_needed, monitor, or none */
  next_action_priority?: string | null;
  /** Parent claim ID for corrections/voids */
  parent_claim_id?: string | null;
  /** Patient control number (PCN) */
  patient_control_number?: string | null;
  /** Patient ID */
  patient_id?: string | null;
  /** Patient display name (enriched) */
  patient_name?: string | null;
  /** Patient responsibility amount from ERA */
  patient_responsibility_cents?: number | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** Payer UUID */
  payer_uuid?: string | null;
  /** Top CARC code (e.g., CO-16) */
  primary_denial_code?: string | null;
  /** Human-readable denial reason */
  primary_denial_description?: string | null;
  /** Provider ID */
  provider_id?: string | null;
  /** Provider display name */
  provider_name?: string | null;
  /** Blocked level: org, entity, or claim_data */
  readiness_blocked_level?: string | null;
  /** Human-readable blocker description */
  readiness_blocked_message?: string | null;
  /** Submission readiness: READY or BLOCKED */
  readiness_status?: string | null;
  /** Service date from */
  service_date_from?: string | null;
  /** Service date to */
  service_date_to?: string | null;
  /** Origin system */
  source_system?: string;
  /** Claim lifecycle status */
  status: string;
  /** When claim was submitted */
  submitted_at?: string | null;
  /** Message of the highest-severity annotation */
  top_blocker?: string | null;
  /** Total charge amount in cents */
  total_charge_cents?: number | null;
  /** When claim was last updated */
  updated_at: string;
  /** Number of WARNING severity annotations */
  warning_count?: number;
};
export type OrgClaimListResponse = {
  /** List of enriched claim items */
  claims: ClaimListItem[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of claims */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type ClaimQueueCounts = {
  /** Draft claims with blockers */
  blocked?: number;
  /** Denied claims */
  denied?: number;
  /** Imported historical claims */
  imported?: number;
  /** Claims needing immediate action */
  needs_attention?: number;
  /** Paid or partially paid claims */
  paid?: number;
  /** Claims ready for submission */
  ready_to_submit?: number;
  /** Claims in-flight (submitted/acknowledged/accepted) */
  submitted?: number;
  /** Total claim count */
  total?: number;
};
export type ClaimDetailLineage = {
  /** IDs of correction/void claims derived from this claim */
  child_claim_ids?: string[];
  /** ID of the original claim this was corrected/voided from */
  parent_claim_id?: string | null;
};
export type OrgClaimDetailResponse = {
  /** Full claim data */
  claim: {
    [key: string]: any;
  };
  /** Parent and child claim relationships */
  lineage: ClaimDetailLineage;
};
export type CptChargeOutput = {
  /** Charge amount in cents */
  charge_cents: number;
  /** Normalized CPT code */
  cpt_code: string;
  /** When the charge was created */
  created_at?: string | null;
  /** Provider ID who owns this charge */
  provider_id: string;
  /** When the charge was last updated */
  updated_at?: string | null;
};
export type CptChargesLookupResponse = {
  /** CPT charges that were found */
  found_charges?: CptChargeOutput[];
  /** Number of charges found */
  found_count: number;
  /** CPT codes that were not found */
  not_found_codes?: string[];
  /** Number of codes not found */
  not_found_count: number;
  /** Provider ID for the lookup */
  provider_id: string;
  /** Total number of CPT codes requested */
  total_requested: number;
};
export type CptChargesLookupRequest = {
  /** List of CPT codes to look up */
  cpt_codes: string[];
};
export type CptChargeResponse = {
  /** Remembered charge amount in cents (e.g., 8550 for $85.50), or null if not found */
  charge_cents?: number | null;
};
export type OrgBillingEncounterResponse = {
  appointment_id?: string | null;
  appointment_info?: {
    [key: string]: any;
  } | null;
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  billable?: boolean;
  canonical_service_type?: {
    [key: string]: any;
  } | null;
  canonical_service_type_slug?: string | null;
  claim_id?: string | null;
  claim_status?: string | null;
  cpt_analysis?: {
    [key: string]: any;
  } | null;
  cpt_codes?: string[];
  created_at?: string | null;
  date_of_service?: string | null;
  encounter_id: string;
  /** Number of CPT codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  has_audit?: boolean;
  has_claim?: boolean;
  icd10_codes?: string[];
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  is_signed?: boolean;
  last_audit_at?: string | null;
  latest_compliance_pct?: number | null;
  latest_quality_score?: number | null;
  modality?: string | null;
  note_id?: string | null;
  note_ids?: string[];
  outputs?: any[];
  patient_id?: string | null;
  patient_info?: {
    [key: string]: any;
  } | null;
  patient_name?: string | null;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  provider_id: string;
  provider_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
  scheduled_for?: string | null;
  service_rendered_at?: string | null;
  status: string;
  summary?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type OrgBillingEncounterListResponse = {
  /** List of billing encounters */
  encounters: OrgBillingEncounterResponse[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of encounters */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type ClaimReferenceResponse = {
  claim_type?: string | null;
  created_at?: string | null;
  id: string;
  insurance_payer_name?: string | null;
  status: string;
  submitted_at?: string | null;
  total_charge_cents?: number;
};
export type NoteAuditSummary = {
  completed_at?: string | null;
  compliance_improvement?: number | null;
  current_revision?: number | null;
  encounter_id?: string | null;
  first_audit_at?: string | null;
  is_completed?: boolean;
  last_audit_at?: string | null;
  latest_compliance_pct?: number | null;
  latest_cpt_match?: boolean | null;
  latest_quality_score?: number | null;
  latest_status?: string | null;
  note_audit_id: string;
  note_id: string;
  note_title?: string | null;
  patient_name?: string | null;
  provider_name?: string | null;
  quality_improvement?: number | null;
  total_revisions?: number | null;
  user_id?: string | null;
  within_quota?: boolean | null;
};
export type AuditRevisionDetail = {
  audit_data?: {
    [key: string]: any;
  } | null;
  compliance_delta?: number | null;
  compliance_percentage?: number | null;
  cpt_analysis_performed?: boolean | null;
  cpt_match?: boolean | null;
  created_at?: string | null;
  overall_quality_score?: number | null;
  provider_cpt_codes?: string[] | null;
  quality_delta?: number | null;
  recommended_cpt_codes?: string[] | null;
  revision?: number | null;
  rules_compliant?: number | null;
  rules_non_compliant?: number | null;
  rules_warning?: number | null;
  status?: string | null;
  target_cpt_codes?: string[] | null;
  target_cpt_source?: string | null;
  trigger?: string | null;
};
export type NoteAuditDetail = {
  audit: NoteAuditSummary;
  current_revision?: AuditRevisionDetail | null;
  patient_name?: string | null;
  provider_name?: string | null;
};
export type EncounterBillingSummary = {
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type OrgBillingEncounterDetailResponse = {
  analyzed_at?: string | null;
  appointment_id?: string | null;
  appointment_info?: {
    [key: string]: any;
  } | null;
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  billable?: boolean;
  canonical_service_type?: {
    [key: string]: any;
  } | null;
  canonical_service_type_slug?: string | null;
  claim_id?: string | null;
  claim_status?: string | null;
  /** All claim references for this encounter */
  claims?: ClaimReferenceResponse[];
  cpt_codes?: string[];
  created_at?: string | null;
  date_of_service?: string | null;
  /** Full encounter analysis data from cortex */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  encounter_id: string;
  /** Number of CPT codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  has_claim?: boolean;
  icd10_codes?: string[];
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  is_signed?: boolean;
  modality?: string | null;
  /** All note audits for this encounter */
  note_audits?: NoteAuditDetail[];
  note_id?: string | null;
  note_ids?: string[];
  outputs?: any[];
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary | null;
  patient_id?: string | null;
  patient_info?: {
    [key: string]: any;
  } | null;
  patient_name?: string | null;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  provider_id: string;
  provider_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
  scheduled_for?: string | null;
  service_rendered_at?: string | null;
  status: string;
  summary?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type EncounterReadinessResponse = {
  /** Audit quality status: green, yellow, red, or null (no audit) */
  audit_status?: string | null;
  /** Reasons for audit status */
  audit_status_reasons?: string[];
  encounter_id: string;
  /** Number of billing codes with fee schedule matches */
  fee_schedule_line_count?: number;
  /** Total fee schedule amount in cents */
  fee_schedule_total_cents?: number | null;
  /** Specific missing information items */
  info_missing?: string[];
  /** Information completeness status: green or red */
  info_status?: string;
  /** Primary insurance payer name */
  primary_payer_name?: string | null;
  /** Composite ready-to-bill status: green, yellow, or red */
  ready_to_bill?: string | null;
  /** Combined reasons from audit and info checks */
  ready_to_bill_reasons?: string[];
};
export type BaselineRateResponse = {
  /** Charge amount in cents */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:90834') */
  code_id: string;
  /** Legacy CPT code (e.g., '90834') */
  cpt_code: string;
  /** Date this rate takes effect */
  effective_date: string;
  /** Fee schedule entry ID */
  id: string;
};
export type BaselineRatesGetResponse = {
  /** Number of rates returned */
  count: number;
  /** Organization ID */
  organization_id: string;
  /** Current baseline rates */
  rates?: BaselineRateResponse[];
};
export type BaselineRateUpsertResultItem = {
  /** Charge amount in cents */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:90834') */
  code_id: string;
  /** Legacy CPT code (e.g., '90834') */
  cpt_code: string;
  /** True if newly created, False if updated */
  created: boolean;
  /** Date this rate takes effect */
  effective_date: string;
  /** Fee schedule entry ID */
  id: string;
};
export type BaselineRatesUpsertResponse = {
  /** Number of new rates created */
  created_count: number;
  /** Organization ID */
  organization_id: string;
  /** Upserted rates with created/updated flags */
  rates?: BaselineRateUpsertResultItem[];
  /** Number of existing rates updated */
  updated_count: number;
};
export type BaselineRateItem = {
  /** Charge amount in cents (e.g., 15000 for $150.00) */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:90834', 'HCPCS:H0031') */
  code_id?: string | null;
  /** Legacy CPT code (e.g., '90834'). Use code_id instead. */
  cpt_code?: string | null;
};
export type BaselineRatesUpsertRequest = {
  /** Date these rates take effect (defaults to today) */
  effective_date?: string | null;
  /** List of billing codes and their charge amounts */
  rates: BaselineRateItem[];
};
export type BaselineRateDeleteResponse = {
  /** Billing code ID that was deleted */
  code_id: string;
  /** Whether deletion was successful */
  deleted: boolean;
};
export type FeeScheduleImportResponse = {
  /** Effective date applied to all imported rows */
  effective_date: string;
  /** Resolved local payer UUID, or null if not matched */
  payer_id?: string | null;
  /** Extracted payer name from document */
  payer_name?: string | null;
  /** Newly created rows */
  rows_created: number;
  /** Total rows written (created + updated) */
  rows_imported: number;
  /** Rows skipped (invalid code_id, zero charge, or error) */
  rows_skipped: number;
  /** Updated existing rows */
  rows_updated: number;
};
export type FeeScheduleRowCorrectionItem = {
  /** Charge amount in cents (e.g., 12000 for $120.00) */
  charge_cents: number;
  /** Billing code ID (e.g., 'CPT:99213', 'HCPCS:H0031') */
  code_id: string;
  /** Rate-affecting modifiers (e.g., {'modifier': 'HO'}) or {} for default */
  modifiers?: {
    [key: string]: any;
  };
};
export type FeeScheduleImportRequest = {
  /** Override extracted effective date. Defaults to date in extraction or today. */
  effective_date?: string | null;
  /** ID of the ClinicDocumentExtractionResult to import from (task='fee_schedule') */
  extraction_result_id: string;
  /** User-corrected rows. If provided, replaces all extracted rows. */
  rows?: FeeScheduleRowCorrectionItem[] | null;
};
export type OrgInvoiceResponse = {
  /** Total amount in cents */
  amount_cents: number;
  /** Invoice creation timestamp */
  created_at: string;
  /** Invoice description */
  description?: string | null;
  /** Linked encounter ID */
  encounter_id?: string | null;
  /** Internal invoice UUID */
  id: string;
  /** When the invoice was paid */
  paid_at?: string | null;
  /** Patient UUID */
  patient_id: string;
  /** Linked ERA remittance claim ID */
  remittance_claim_id?: string | null;
  /** Invoice status */
  status: string;
  /** Stripe invoice ID */
  stripe_invoice_id: string;
};
export type OrgInvoiceListResponse = {
  /** List of invoices */
  invoices?: OrgInvoiceResponse[];
};
export type LedgerEntryItem = {
  /** Positive = increases A/R, negative = decreases */
  amount_cents: number;
  created_at: string;
  description?: string | null;
  encounter_id?: string | null;
  entry_id: string;
  /** charge, payment, adjustment, transfer, etc. */
  entry_type: string;
  /** payer or patient */
  party_type: string;
  source_id?: string | null;
  /** claim_submission, era_posting, stripe_webhook, etc. */
  source_type: string;
};
export type PatientBalanceResponse = {
  /** Paginated ledger entries */
  entries?: LedgerEntryItem[];
  /** Current page */
  page?: number;
  /** Null if no billing account exists yet */
  patient_billing_account_id?: string | null;
  patient_id: string;
  /** Items per page */
  per_page?: number;
  /** Total number of entries */
  total?: number;
  /** Positive = patient owes, negative = credit */
  total_balance_cents: number;
  /** Total pages */
  total_pages?: number;
};
export type RecordPaymentResponse = {
  /** True if payment was allocated to charge_lines */
  allocated: boolean;
  /** Amount recorded in cents */
  amount_cents: number;
  /** ID of the created ledger entry */
  ledger_entry_id: string;
};
export type RecordPaymentRequest = {
  /** Payment amount in cents */
  amount_cents: number;
  /** Scope payment to an encounter for allocation */
  encounter_id?: string | null;
  /** Optional note about the payment */
  note?: string | null;
  /** Payment method: cash, check, external */
  payment_method: string;
  /** Check number, receipt number, etc. */
  reference_number?: string | null;
};
export type RemittanceListItem = {
  /** Check number or EFT trace number */
  check_or_eft_trace_number: string;
  /** Total claims in this ERA */
  claim_count?: number;
  created_at?: string | null;
  /** Claims with status code 4 (denied) */
  denied_claim_count?: number;
  /** Claims matched to internal records */
  matched_claim_count?: number;
  payee_name?: string | null;
  payer_identifier?: string | null;
  payer_name?: string | null;
  /** Date the payer issued payment (from 835 DTM*405) */
  payment_date?: string | null;
  /** CHK (check) or ACH (electronic) */
  payment_method_code?: string | null;
  remittance_id: string;
  /** Claims with status code 22 (reversal) */
  reversal_count?: number;
  source_system?: string | null;
  /** Sum of total_claim_charge_amount_cents across all claims */
  total_charge_cents?: number;
  /** Sum of patient_responsibility_amount_cents across all claims */
  total_patient_responsibility_cents?: number;
  /** Total payment in cents across all claims */
  total_payment_amount_cents?: number | null;
};
export type RemittanceListItemResponse = {
  /** Current page number (1-based) */
  page: number;
  /** Number of items per page */
  per_page: number;
  remittances?: RemittanceListItem[];
  /** Total number of remittances matching filters */
  total: number;
  /** Total number of pages available */
  total_pages: number;
};
export type RemittanceQueueCounts = {
  /** Total remittances matching filters */
  all?: number;
  /** Remittances where all claims are matched and processed */
  clean?: number;
  /** Remittances with at least one denied claim */
  has_denials?: number;
  /** Remittances from historical imports */
  imported?: number;
  /** Remittances with at least one reversal */
  reversals?: number;
};
export type StatementHistoryItem = {
  completed_at?: string | null;
  created_at?: string | null;
  error_count?: number;
  statement_run_id: string;
  status: string;
  total_amount_cents: number;
  total_invoices_created: number;
  trigger_type: string;
  triggered_by?: string | null;
};
export type StatementHistoryListResponse = {
  items?: StatementHistoryItem[];
  /** Current page (1-based) */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total items matching filters */
  total: number;
  /** Total pages */
  total_pages: number;
};
export type StatementChargeLineItem = {
  billing_code?: string | null;
  charge_line_id: string;
  description?: string | null;
  encounter_id?: string | null;
  patient_due_amount_cents?: number;
};
export type StatementQueueItem = {
  balance_cents: number;
  /** Eligible charge_line IDs — pass these to Send Invoice for allocation */
  charge_line_ids?: string[];
  created_at?: string | null;
  encounter_count: number;
  /** Breakdown of eligible charges for review */
  line_items?: StatementChargeLineItem[];
  patient_billing_account_id: string;
  patient_id: string;
  patient_name: string;
  statement_run_id: string;
  trigger_type: string;
};
export type StatementQueueListResponse = {
  items?: StatementQueueItem[];
  /** Current page (1-based) */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total items matching filters */
  total: number;
  /** Total pages */
  total_pages: number;
};
export type AppointmentResponseBase = {
  /** Appointment ID */
  appointment_id: string;
  /** Color for appointment display (inherited from encounter type) */
  color?: string | null;
  /** Patient confirmation status (scheduled, cancelled, reschedule_requested, confirmed) */
  confirmation_status?: string | null;
  /** Creation timestamp */
  created_at: string;
  /** Daily.co room metadata for telehealth appointments (room_name, room_url, etc.) */
  daily_room_metadata?: {
    [key: string]: any;
  } | null;
  /** Calculated display title combining patient name and encounter type */
  display_title?: string | null;
  /** Appointment duration in minutes */
  duration: number;
  /** Encounter type name */
  encounter_type?: string | null;
  /** Encounter type ID */
  encounter_type_id?: string | null;
  /** Form rules for this appointment */
  form_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Flexible metadata for additional appointment data (e.g., suggested_action_id) */
  metadata?: {
    [key: string]: any;
  };
  /** Whether patient did not show up for appointment */
  no_showed?: boolean;
  /** Free-form notes for this appointment */
  notes?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Whether rules are locked from being overridden by defaults */
  override_defaults?: boolean;
  /** Provider ID. None for unassigned appointments. */
  provider_id?: string | null;
  /** Reminder rules for this appointment */
  reminder_rules?:
    | {
        [key: string]: any;
      }[]
    | null;
  /** Whether rules are locked from being updated */
  rules_locked?: boolean;
  /** Series ID if part of a recurring series */
  series_id?: string | null;
  /** Appointment start time */
  start_time: string;
  /** Appointment status */
  status: string;
  /** Whether this is a telehealth/virtual appointment */
  telehealth?: boolean | null;
  /** Template ID associated with encounter type */
  template_id?: string | null;
  /** Appointment title */
  title?: string | null;
  /** Last update timestamp */
  updated_at: string;
};
export type ClaimReference = {
  /** Claim type (original, corrected, void) */
  claim_type?: string | null;
  /** When the claim was created */
  created_at?: string | null;
  /** Claim UUID */
  id: string;
  /** Insurance payer name for display */
  insurance_payer_name?: string | null;
  /** Claim status (draft, processing, ready, submitted, acknowledged, accepted, rejected) */
  status: string;
  /** When the claim was submitted */
  submitted_at?: string | null;
  /** Total charges in cents */
  total_charge_cents?: number;
};
export type ComputedDefaults = {
  /** Default values for attestation checkboxes */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Default CPT codes from encounter type */
  cpt_codes?: string[];
  /** Default ICD-10 codes from last patient encounter */
  icd10_codes?: string[];
  /** Default modality */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Default place of service code */
  place_of_service?: string | null;
};
export type DocumentCountsMap = {
  /** Map of document type to count */
  counts: {
    [key: string]: number;
  };
  /** Total count of all documents */
  total: number;
};
export type DocumentSummary = {
  /** Count of input documents by type */
  input_counts: DocumentCountsMap;
  /** Count of output documents by type */
  output_counts: DocumentCountsMap;
};
export type EncounterDocumentReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** Encounter document ID */
  encounter_document_id: string;
  /** Output status */
  status?: "pending" | "completed";
  /** Document title for display */
  title?: string | null;
  /** Document type */
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  /** Creation timestamp */
  created_at?: string | null;
  /** JotDoc ID (None for pending outputs) */
  jotdoc_id?: string | null;
  /** Output status */
  status?: "pending" | "completed";
  /** Task ID for tracking (optional, for debugging) */
  task_id?: string | null;
  /** Thread ID for building SSE stream URL */
  thread_id?: string | null;
  /** Document title */
  title?: string | null;
  /** Document type */
  type?: string;
};
export type InsuranceSummary = {
  /** Coverage priority: 1=primary, 2=secondary, 3=tertiary */
  coverage_order?: number;
  /** Group/employer number */
  group_number?: string | null;
  /** Member/policy ID on insurance card */
  member_id?: string | null;
  /** Payer logo image URL */
  payer_logo_url?: string | null;
  /** Insurance payer display name */
  payer_name?: string | null;
  /** True when payer was resolved with low confidence or unresolved; requires manual verification */
  payer_resolution_needs_review?: boolean | null;
  /** Plan name (e.g. Gold PPO) */
  plan_name?: string | null;
  /** Coverage status: active, pending, cancelled, expired */
  status?: string;
};
export type PatientInfo = {
  dob?: string | null;
  first_name?: string | null;
  identifier?: string | null;
  /** Active insurance coverages with payer info */
  insurance_coverages?: InsuranceSummary[] | null;
  last_name?: string | null;
  middle_name?: string | null;
  name?: string | null;
  patient_id: string;
  preferred_name?: string | null;
  telephone?: string | null;
};
export type EncounterBillingSummary2 = {
  /** Most recent PAYMENT entry date */
  last_payment_date?: string | null;
  /** Net encounter-scoped patient balance */
  patient_balance_cents: number;
  /** Highest-priority status across charge_lines */
  patient_due_status: string;
  /** Sum of charge_line amounts for this encounter */
  total_charge_cents: number;
  /** Sum of patient PAYMENT entries for this encounter */
  total_paid_cents: number;
  /** Account-level unallocated credit */
  unapplied_credit_cents: number;
};
export type WorkingBillingClaimLineItemResponse = {
  /** Charge amount in cents for the line item */
  charge_cents?: number | null;
  /** Billing code identifier */
  code_id?: string | null;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  /** Provenance for each modifier, keyed by modifier code */
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  /** Whether this line item came from provider edits or AI */
  source?: ("provider_selected" | "ai_recommended") | null;
  /** Units billed */
  units?: number | null;
};
export type WorkingBillingClaimResponse = {
  created_at?: string | null;
  /** Provenance for each diagnosis code, keyed by normalized ICD-10 code */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  diagnosis_codes?: string[];
  encounter_id?: string | null;
  line_items?: WorkingBillingClaimLineItemResponse[];
  organization_id?: string | null;
  place_of_service?: string | null;
  updated_at?: string | null;
};
export type EncounterResponse = {
  /** Associated appointment if any */
  appointment?: AppointmentResponseBase | null;
  /** Flexible attestation data */
  attestations?: {
    [key: string]: any;
  } | null;
  /** Whether the current user can delete transcripts (owner or org admin) */
  can_delete_transcripts?: boolean | null;
  /** Associated claims for this encounter (all versions: original, corrected, void) */
  claims?: ClaimReference[] | null;
  /** Suggested default values based on patient, encounter_type, and modality. Frontend can apply these when appropriate. */
  computed_defaults?: ComputedDefaults | null;
  /** CPT codes selected for this encounter */
  cpt_codes?: string[];
  /** Creation timestamp */
  created_at: string;
  /** Canonical billing date (CMS-1500 Box 24A) */
  date_of_service?: string | null;
  /** Summary of document counts */
  document_summary?: DocumentSummary | null;
  /** Encounter analysis payload if available */
  encounter_analysis?: {
    [key: string]: any;
  } | null;
  /** Encounter ID */
  encounter_id: string;
  /** Encounter type */
  encounter_type?: string | null;
  /** Encounter end time */
  end_time?: string | null;
  /** ICD-10 diagnosis codes for billing (max 4, first is primary) */
  icd10_codes?: string[];
  /** Input documents or recordings */
  inputs?: EncounterDocumentReference[];
  /** How the encounter was conducted */
  modality?: ("in_person" | "video" | "audio") | null;
  /** Last modification timestamp */
  modified_at?: string | null;
  /** Legacy note ID */
  note_id?: string | null;
  /** Note title */
  note_title?: string | null;
  /** Organization ID */
  organization_id?: string | null;
  /** Output documents or notes */
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  /** Associated patient information */
  patient?: PatientInfo | null;
  /** Patient financial summary for this encounter. None if no charge_lines exist yet (pre-claim-submission). */
  patient_billing?: EncounterBillingSummary2 | null;
  /** Patient ID */
  patient_id?: string | null;
  /** CMS place of service code (e.g., '11', '10', '02') */
  place_of_service?: string | null;
  /** Provider ID */
  provider_id: string;
  /** Timestamp confirming service was rendered */
  service_rendered_at?: string | null;
  /** Encounter start time */
  start_time?: string | null;
  /** Encounter status */
  status: string;
  /** Template ID */
  template_id?: string | null;
  /** Whether transcripts have been deleted for this encounter */
  transcripts_deleted?: boolean;
  /** Last update timestamp */
  updated_at: string;
  /** Canonical encounter-level working billing claim (read-only) */
  working_billing_claim?: WorkingBillingClaimResponse | null;
};
export type WorkingClaimLineItem = {
  charge_cents?: number | null;
  code_id: string;
  /** Subset of claim-level diagnosis codes this line links to. Empty = all apply. */
  diagnosis_codes?: string[];
  modifier_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  };
  modifiers?: string[];
  source: "provider_selected" | "ai_recommended";
  units?: number;
};
export type WorkingBillingClaimPutRequest = {
  /** Optional provenance for each diagnosis code. If omitted, all codes are marked provider_selected. */
  diagnosis_code_sources?: {
    [key: string]: "provider_selected" | "ai_recommended";
  } | null;
  /** ICD-10 diagnosis codes for the claim (max 4 after normalization) */
  diagnosis_codes?: string[];
  /** Optimistic concurrency token. If provided and stale, update returns 409. */
  expected_updated_at?: string | null;
  /** Full replacement list of claim line items */
  line_items?: WorkingClaimLineItem[];
  /** CMS place of service code (e.g. '11', '02') */
  place_of_service?: string | null;
};
export type BillingAddressResponse3 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type ServiceFacilityResponse = {
  address: BillingAddressResponse3;
  created_at: string;
  display_name: string;
  facility_npi: string | null;
  facility_other_id: string | null;
  is_default: boolean;
  organization_id: string;
  service_facility_id: string;
  updated_at: string;
};
export type ServiceFacilityListResponse = {
  service_facilities: ServiceFacilityResponse[];
};
export type BillingAddressResponse4 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type ServiceFacilityResponse2 = {
  address: BillingAddressResponse4;
  created_at: string;
  display_name: string;
  facility_npi: string | null;
  facility_other_id: string | null;
  is_default: boolean;
  organization_id: string;
  service_facility_id: string;
  updated_at: string;
};
export type BillingAddressSchema2 = {
  city: string;
  line1: string;
  line2?: string | null;
  state: string;
  zip: string;
};
export type CreateServiceFacilityRequest = {
  address: BillingAddressSchema2;
  display_name: string;
  facility_npi?: string | null;
  facility_other_id?: string | null;
  is_default?: boolean;
};
export type ServiceFacilityDeleteResponse = {
  /** Whether deletion was successful */
  deleted: boolean;
};
export type BillingAddressUpdateSchema2 = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  state?: string | null;
  zip?: string | null;
};
export type UpdateServiceFacilityRequest = {
  address?: BillingAddressUpdateSchema2 | null;
  display_name?: string | null;
  facility_npi?: string | null;
  facility_other_id?: string | null;
  is_default?: boolean | null;
};
